import { ReactElement } from 'react';
import { Message } from '@messageformat/react';
import { IconBank, IconInternational } from '@op/opds.opux-icons/misc';
import { IconRight } from '@op/opds.opux-icons/navigation';
import styles from './InfoTextBox.module.scss';

const InfoTextBox2 = (): ReactElement => {
  return (
    <div className={styles.container}>
      <div aria-labelledby="considering">
        <div className={styles.centeredContainer}>
          <div className={styles.iconRow}>
            <IconInternational size="large" />
            <IconRight size="large" />
            <IconBank size="large" />
          </div>

          <p className="opds-styles-v1-text-body-medium">
            <Message id="course8.part1.infobox2.body1" />
          </p>
        </div>
        <div className={styles.centeredContainer}>
          <div className={styles.iconRow}>
            <IconBank size="large" />
            <IconRight size="large" />
            <IconInternational size="large" />
          </div>

          <p className="opds-styles-v1-text-body-medium">
            <Message id="course8.part1.infobox2.body2" />
          </p>
        </div>
      </div>
    </div>
  );
};

export default InfoTextBox2;
